export const getObserverConfig = (index: number, total: number) => {
  if (index === 0) return { rootMargin: '0px 0px -80% 0px', threshold: 0 };
  if (index === total - 1) return { rootMargin: '-10% 0px 0px 0px', threshold: 0.1 };
  return { rootMargin: '-10% 0px -60% 0px', threshold: 0.1 };
};
